import { Injectable, Renderer2, RendererFactory2 } from "@angular/core";
import { dateTimeData } from "../types/types";
import { AbstractControl, ValidationErrors } from "@angular/forms";

@Injectable({
    providedIn: 'root'
})
export class CommonSharedService {

    private renderer: Renderer2;
    constructor(private rendererFactory: RendererFactory2) {
        this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    initializeAcceptBlueTokenizationURL(tokenizationAPIURL: string) {

        //Delete existing object so it doesn't throw error (window.HostedTokenization si already defined.)
        delete (window as any)?.HostedTokenization;

        const scriptElement = document.getElementById('tokenization-api-url');
        scriptElement?.parentElement?.removeChild(scriptElement);

        const script = this.renderer.createElement('script');
        script.src = tokenizationAPIURL;
        script.id = 'tokenization-api-url';
        this.renderer.appendChild(document.head, script);

    }

    initializeAcceptBluePaymentIframe(tokenizationSourceKey: string): any {
        return new Promise((resolve, reject) => {

            setTimeout(() => {
                const hostedTokenization = new (window as any).HostedTokenization(tokenizationSourceKey);
                const cardForm = hostedTokenization.create('card-form');

                cardForm.mount('#trigger-card-payment');
                cardForm.setStyles({
                    container: 'display: grid; width:100%',
                    card: "width: 100%; font-size: 1rem; color: #334155;background: #ffffff;padding: 0.75rem 0.75rem;border: 1px solid #cbd5e1;border-radius: 6px;margin-bottom: 1rem;    box-sizing: border-box;",
                    expiryMonth: "width: calc(50% - 4px); font-size: 1rem; color: #334155;background: #ffffff;padding: 0.75rem 0.75rem;border: 1px solid #cbd5e1;border-radius: 6px;margin-bottom: 1rem;    box-sizing: border-box;",
                    expirySeparator: "display: none",
                    expiryYear: "width: calc(50% - 4px); font-size: 1rem; color: #334155;background: #ffffff;padding: 0.75rem 0.75rem;border: 1px solid #cbd5e1;border-radius: 6px;margin-bottom: 1rem;    box-sizing: border-box;",
                    cvv2: "width: 50%; font-size: 1rem; color: #334155;background: #ffffff;padding: 0.75rem 0.75rem;border: 1px solid #cbd5e1;border-radius: 6px;margin-bottom: 1rem;    box-sizing: border-box;"
                });
                resolve(cardForm);
            }, 0);
        });
    }

    splitNameToParts(name: string, part: string) {

        // If we weren't given a string then return an empty value
        if (typeof name === 'undefined') {
            return '';
        }

        // Assume everyhing after the last space is part of the last name
        // Everything before the last space is the first name.
        let lastSpacePos: number = name.lastIndexOf(' ');

        if (lastSpacePos >= 0) {
            // The name is in two parts.
            if (part === 'first') {
                return name.slice(0, lastSpacePos);
            }

            if (part === 'last') {
                return name.slice(lastSpacePos + 1);
            }
        } else {
            // The name isn't in two parts so the first part will be the first name
            if (part === 'first') {
                return name;
            }

            if (part === 'last') {
                return '';
            }
        }

        return '';
    }

    joinName(first: string, last: string): string {
        first = first.trim();
        last = last.trim();

        if (!first) { return last; }

        if (!last) { return first; }

        const name = (first + ' ' + last).trim();

        return name;
    }

    /**
     * This function will split year, month, day, hour, minute, seconds from string
     * @param date string
     * @returns object
     */
    extractDateTimeFromString(date: string): dateTimeData {
        let [lastAutopayDate, lastAutopayTime] = (date.split("."))[0].split("T")
        let [year, month, day]: number[] = lastAutopayDate.split("-").map((value: string) => Number(value));
        let [hours, minutes, seconds]: number[] = lastAutopayTime.split(":").map((value: string) => Number(value));

        return { year: year, month: month, day: day, hours: hours, minutes: minutes, seconds: seconds } as dateTimeData;
    }

    /**
     * Given a string that is currency strip off the formatting and return as a number.
     * I.e. $1,234.56 converts to 1234.56
     *
     * @param unitprice
     */
    convertCurrencyStringToNumber(unitprice: string): number {
        return Number(unitprice.replaceAll("$", "").replaceAll(",", ""));
    }

    cleanUrl(fullUrl: string): string {
        return fullUrl
            .trim()                // remove spaces at start/end
            .replace(/\s+/g, "")    // remove ALL spaces inside
            .replace(/\/+$/, "");  // remove trailing slashes
    }

    /**
     * This function validates a comma-separated list of email addresses in an Angular FormControl. 
     * @param control reactive form control
     * @returns null or { invalidEmails: true } if any email address is invalid.
     */
    multiEmailValidator(control: AbstractControl): ValidationErrors | null {
        let value = control.value?.trim();

        // Empty value is fine (not required)
        if (!value) {
            return null;
        }
        
        // Normalize value: remove spaces or '+' around commas
        value = value.replace(/\s*,\s*/g, ',').replace(/\+*,\+*/g, ',').trim();

        // Split by commas
        const emails = value.split(',').map((e: string) => e.trim()).filter((e: string) => e);

        // Basic email regex (same as Angular's Validators.email)
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        // Check if any email is invalid
        const invalid = emails.some((email: string) => !emailRegex.test(email));

        return invalid ? { invalidEmails: true } : null;
    }
}